
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Bestpicnicspotnearbuldhana() {



  const cardData =
  {
    keyword: ' Best Picnic Spot Near Buldhana',
    heading:  'Woodland Escape: Best Picnic Spot Near Buldhana ',
    headingDescription: 'Woodland Escape Resort, one of the best picnic spots near Buldhana, offers a perfect blend of natural beauty, relaxation, and fun just a short drive from the city. Nestled amidst lush greenery, open lawns, and serene forested areas, the resort provides an ideal setting for families, friends, and groups to unwind and enjoy quality time together. Guests can explore scenic picnic spots, take leisurely nature walks, indulge in outdoor games, or relax in cozy cottages while soaking in the tranquil surroundings. With delicious meals, warm hospitality, and well-planned recreational spaces, Woodland Escape Resort near Buldhana ensures every picnic is memorable, refreshing, and filled with joy in the heart of nature.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
{
"name": "Best Picnic Spot Near Buldhana",
"description": "Discover the best picnic spots near Buldhana offering lush greenery, peaceful surroundings, and recreational activities for families and friends to enjoy a perfect day outdoors."
},
{
"name": "Buldhana Top Picnic Places",
"description": "Explore the top picnic destinations in Buldhana, featuring scenic landscapes, well-maintained gardens, riversides, and hill views that make every outing memorable."
},
{
"name": "Buldhana Family Picnic Spot",
"description": "Plan a family picnic in Buldhana with kid-friendly amenities, open spaces, and fun activities ensuring an enjoyable experience for all age groups."
},
{
"name": "Buldhana Nature Picnic Spot",
"description": "Reconnect with nature at Buldhana’s serene picnic locations surrounded by forests, rivers, and hills, perfect for nature walks and outdoor relaxation."
},
{
"name": "Affordable Picnic Spot Buldhana",
"description": "Enjoy budget-friendly picnic spots in Buldhana that provide great amenities, scenic surroundings, and recreational activities without stretching your budget."
},
{
"name": "Buldhana Weekend Picnic",
"description": "Spend a refreshing weekend at Buldhana’s picnic spots, ideal for short trips with family or friends to unwind from city life and enjoy nature."
},
{
"name": "Buldhana Riverside Picnic Spot",
"description": "Relax by the riverside at Buldhana’s picnic locations, offering tranquil water views, picnic tables, and opportunities for water-based activities."
},
{
"name": "Buldhana Garden Picnic Spot",
"description": "Visit beautifully maintained garden picnic spots in Buldhana with flowering landscapes, seating areas, and open lawns perfect for a leisurely day out."
},
{
"name": "Buldhana Hill Picnic Spot",
"description": "Enjoy panoramic hill views and cool breezes at Buldhana’s hilltop picnic spots, ideal for photography, nature walks, and serene getaways."
},
{
"name": "Buldhana Kids Friendly Picnic Spot",
"description": "Take your children to safe and entertaining picnic locations in Buldhana with play areas, greenery, and activities designed for young ones."
},
{
"name": "Buldhana Scenic Picnic Spot",
"description": "Capture stunning landscapes and enjoy breathtaking scenery at Buldhana’s picnic destinations, perfect for photography and peaceful relaxation."
},
{
"name": "Buldhana Outdoor Picnic Spot",
"description": "Experience open-air recreation at Buldhana’s outdoor picnic spots with ample space for games, barbecues, and group activities."
},
{
"name": "Buldhana Picnic Spot Booking",
"description": "Book your preferred picnic spot in Buldhana in advance to ensure a hassle-free outing with guaranteed amenities and facilities."
},
{
"name": "Buldhana Picnic Tour Packages",
"description": "Explore curated picnic tour packages in Buldhana that include transport, meals, and guided activities for a complete day-out experience."
},
{
"name": "Buldhana Best Weekend Picnic Spot",
"description": "Plan your weekend getaway to the best picnic spots in Buldhana, combining scenic beauty, relaxation, and family-friendly activities for a memorable outing."
}
],
"tableData": [
["- Best Picnic Spot Near Buldhana", "- Buldhana Top Picnic Places"],
["- Buldhana Family Picnic Spot", "- Buldhana Nature Picnic Spot"],
["- Affordable Picnic Spot Buldhana", "- Buldhana Weekend Picnic"],
["- Buldhana Riverside Picnic Spot", "- Buldhana Garden Picnic Spot"],
["- Buldhana Hill Picnic Spot", "- Buldhana Kids Friendly Picnic Spot"],
["- Buldhana Scenic Picnic Spot", "- Buldhana Outdoor Picnic Spot"],
["- Buldhana Picnic Spot Booking", "- Buldhana Picnic Tour Packages"],
["- Buldhana Best Weekend Picnic Spot", ""]
],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Picnic Spot Near Buldhana",
    "WhyChoosedescription": "Woodland Escape Resort provides a scenic and tranquil environment near Buldhana, ideal for a relaxing family picnic. Surrounded by lush greenery and forested landscapes, it offers a refreshing escape from city life."
  },
  {
    "WhyChooseheading": "Peaceful Forest Ambience",
    "WhyChoosedescription": "The resort is nestled amidst dense trees and serene natural surroundings, creating a calm atmosphere for your picnic. Guests can enjoy the sights and sounds of nature while unwinding and spending quality time together."
  },
  {
    "WhyChooseheading": "Comfortable Day-Use Facilities",
    "WhyChoosedescription": "Woodland Escape Resort offers well-equipped picnic areas, shaded sit-outs, and rest zones. Even for a day visit, you can relax comfortably and enjoy meals, games, or leisure activities in a peaceful setting."
  },
  {
    "WhyChooseheading": "Activities for Fun and Relaxation",
    "WhyChoosedescription": "Families and groups can engage in nature walks, light adventure activities, cycling, and pond-side relaxation. The resort provides options for both active recreation and leisurely enjoyment suitable for all ages."
  },
  {
    "WhyChooseheading": "Ideal for Family and Group Outings",
    "WhyChoosedescription": "Whether it’s a family picnic, friends’ outing, or small group trip, Woodland Escape Resort offers a safe and expansive environment for bonding, fun games, and memorable experiences."
  },
  {
    "WhyChooseheading": "Delicious Meals and Refreshments",
    "WhyChoosedescription": "Enjoy freshly prepared local meals, snacks, and beverages during your picnic. The resort ensures that your day is not only fun but also satisfying with tasty food options for everyone."
  },
  {
    "WhyChooseheading": "Easily Accessible from Buldhana",
    "WhyChoosedescription": "Located just a short drive from Buldhana, Woodland Escape Resort is convenient for a day outing. Its proximity allows you to spend more time enjoying nature and less time traveling."
  }
]


















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a picnic spot near Buldhana?",
    answer: "Woodland Escape Resort offers a serene, green, and family-friendly environment ideal for a day picnic near Buldhana. Guests can relax amidst nature, enjoy open lawns, and engage in outdoor activities."
  },
  {
    question: "How far is Woodland Escape Resort from Buldhana city?",
    answer: "The resort is approximately 35–40 km from Buldhana, taking around 1 to 1.5 hours by car. It’s a perfect distance for a day outing or weekend picnic."
  },
  {
    question: "What activities are available for picnic guests?",
    answer: "Visitors can enjoy nature walks, cycling, open-lawn games, play areas for kids, and peaceful spots to relax. The resort is designed for both fun and relaxation."
  },
  {
    question: "Is Woodland Escape Resort suitable for family picnics?",
    answer: "Absolutely! The resort is safe, family-friendly, and offers spaces where both children and adults can enjoy themselves comfortably."
  },
  {
    question: "Does the resort provide food for picnic guests?",
    answer: "Yes! Woodland Escape Resort provides freshly prepared meals, snacks, and beverages. Picnic packages can include lunch and refreshments for a hassle-free experience."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Buldhana?",
    answer: "You can book by calling or WhatsApp messaging our reservations team or visiting the official website. Advance booking is recommended, especially on weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Pravin & Family, Buldhana",
    text: "Our picnic at Woodland Escape Resort was fantastic! The surroundings were beautiful, the kids enjoyed the play areas, and the food was delicious. Truly the best picnic spot near Buldhana."
  },
  {
    name: "Miss. Aarti & Friends, Buldhana",
    text: "Woodland Escape Resort made our day out memorable! The green lawns, fun activities, and serene atmosphere were perfect for a picnic. Highly recommended!"
  }
];



















      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Picnic Spot Near Buldhana",
  "image": "https://woodlandescape.com/assets/images/best-picnic-spot-buldhana.jpg",
  "description": "Visit Woodlandescape Resort, the best picnic spot near Buldhana, offering scenic nature, outdoor activities, riverside views, and a perfect weekend getaway for families and friends.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "298"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/best-picnic-spot-buldhana"
  }
};



  return (
    <div>

<Helmet>
  <title>Best Picnic Spot Near Buldhana | Scenic Weekend Getaway | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Plan a fun-filled day at Woodlandescape Resort, the best picnic spot near Buldhana. Enjoy scenic nature, outdoor activities, riverside views, and a perfect weekend outing for families and friends." 
  />
  <meta 
    name="keywords" 
    content="Best Picnic Spot Near Buldhana, Buldhana Top Picnic Places, Buldhana Family Picnic Spot, Buldhana Nature Picnic Spot, Affordable Picnic Spot Buldhana, Buldhana Weekend Picnic, Buldhana Riverside Picnic Spot, Buldhana Garden Picnic Spot, Buldhana Hill Picnic Spot, Buldhana Kids Friendly Picnic Spot, Buldhana Scenic Picnic Spot, Buldhana Outdoor Picnic Spot, Buldhana Picnic Spot Booking, Buldhana Picnic Tour Packages, Buldhana Best Weekend Picnic Spot" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/20.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Bestpicnicspotnearbuldhana;